import DTO from './DTO';

class VehiclesDTO extends DTO {
  device_id;

  provider_id;

  vehicle_id;

  vehicle_type;

  propulsion_types;

  year;

  mfgr;

  model;

  state;

  prev_events;

  updated;

  constructor(params, isValidInit) {
    const attributes = [
      {
        name: 'device_id',
        type: String,
        validators: [],
        labelKey: 'vehicles.device_id',
      },
      {
        name: 'provider_id',
        type: String,
        validators: [],
        labelKey: 'vehicles.provider_id',
      },
      {
        name: 'vehicle_id',
        type: String,
        validators: [],
        labelKey: 'vehicles.vehicle_id',
      },
      {
        name: 'vehicle_type',
        type: String,
        validators: [],
        labelKey: 'vehicles.vehicle_type',
      },
      {
        name: 'propulsion_types',
        type: Array,
        validators: [],
        labelKey: 'vehicles.propulsion_types',
      },
      {
        name: 'year',
        type: String,
        validators: [],
        labelKey: 'vehicles.year',
      },
      {
        name: 'mfgr',
        type: String,
        validators: [],
        labelKey: 'vehicles.mfgr',
      },
      {
        name: 'model',
        type: String,
        validators: [],
        labelKey: 'vehicles.model',
      },
      {
        name: 'state',
        type: String,
        validators: [],
        labelKey: 'vehicles.state',
      },
      {
        name: 'prev_events',
        type: String,
        validators: [],
        labelKey: 'vehicles.prev_events',
      },
      {
        name: 'updated',
        type: String,
        validators: [],
        labelKey: 'vehicles.updated',
      },
      {
        name: 'created_at',
        type: String,
        validators: [],
        labelKey: 'created_at',
      },
    ];
    super(attributes, params, isValidInit);
  }

  getData() {
    return {
      device_id: this.device_id,
      provider_id: this.provider_id,
      vehicle_id: this.vehicle_id,
      vehicle_type: this.vehicle_type,
      propulsion_types: this.propulsion_types,
      year: this.year,
      mfgr: this.mfgr,
      model: this.model,
      state: this.state,
      prev_events: this.prev_events,
      updated: this.updated,
    };
  }
}

export default VehiclesDTO;
